// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slick-track {
  display: flex;
  margin-left: 0px;
  margin-right: 0;
}

.slick-list {
  padding-left: 0px;
}

.slick-slide {
  display: flex;
}

/* .slick-track {
  transform: translateX(-10px) !important;
} */
`, "",{"version":3,"sources":["webpack://./src/HOC/modal/SportsCard/sports.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;GAEG","sourcesContent":[".slick-track {\n  display: flex;\n  margin-left: 0px;\n  margin-right: 0;\n}\n\n.slick-list {\n  padding-left: 0px;\n}\n\n.slick-slide {\n  display: flex;\n}\n\n/* .slick-track {\n  transform: translateX(-10px) !important;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
